import { getPairingUid } from '../../../../../logic/user/user.selectors';
import { getGdprNoticeFeature } from '../../../../../logic/features/features.selectors';

const AUTHENTICATED_ONLY = ['info', 'logout'];

export const getNavigationFeatures = state => {
  const gdprNoticeFeatureEnabled = getGdprNoticeFeature(state);
  const isAuthenticated = getPairingUid(state);

  return {
    ...(isAuthenticated ? undefined : AUTHENTICATED_ONLY.reduce((acc, entry) => ({ ...acc, [entry]: false }), {})),
    privacysettings: gdprNoticeFeatureEnabled,
    // NOTE: we are adding this one on the frontend side
    login: false,
    parentalcontrol: false,
    profilesgate: false,
  };
};
